import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'documentFilter',
    pure: false
})
export class DocumentFilterPipe implements PipeTransform {

    transform(items: any[], filter: Object): any {
        
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // console.log(items,filter);
        // kept, false will be filtered out
        return items.filter(item => {
            if (filter['Shared']) {
                return item.Type === 'SharedFolder' || item.Type === 'SharedFile';
            } else {
                return item.Type === 'DriveFolder' || item.Type === 'DriveFile';
            }
        });
    }

}
